import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../elementals/icon'
import { Dropdown } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const Login = ({
  firstName,
  lastName,
  email,
  showEmail,
  onLogout,
  customClassName,
}) => {
  const profileOptions = [
    {
      key: 'user',
      text: `Logged in as ${firstName} ${lastName}`,
      disabled: true,
      'data-elm-id': 'header_user_dropdown_option_name',
    },
    {
      key: 'log-out',
      text: 'Log Out',
      icon: 'log out',
      onClick: onLogout,
      'data-elm-id': 'header_user_dropdown_option_log_out',
    },
  ]
  const profileTrigger = (
    <span className={cx('user-dropdown-trigger')}>
      <Icon data-elm-id='header_user_dropdown_icon' name='user' />{' '}
      {showEmail && email}
    </span>
  )

  return (
    <Dropdown
      floating
      direction='left'
      trigger={profileTrigger}
      options={profileOptions}
      className={cx('user-dropdown', customClassName)}
      data-elm-id='header_user_dropdown'
    />
  )
}

Login.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  email: PropTypes.string,
  showEmail: PropTypes.bool,
  customClassName: PropTypes.string,
}

export default Login
